import { PermissionDomain } from '../model/types';

export const PERMISSION_DOMAIN_LABEL_MAP: Record<PermissionDomain, string> = {
  [PermissionDomain.Users]: 'Користувачі',
  [PermissionDomain.Roles]: 'Ролі',
  [PermissionDomain.Permissions]: 'Дозволи',
  [PermissionDomain.Clients]: 'Клієнти',
  [PermissionDomain.Contracts]: 'Договори',
  [PermissionDomain.Cards]: 'Картки',
  [PermissionDomain.Pin]: 'PIN',
  [PermissionDomain.Limits]: 'Ліміти',
  [PermissionDomain.LimitTemplates]: 'Шаблони лімітів',
  [PermissionDomain.SystemLimitTemplates]: 'Системні шаблони лімітів',
  [PermissionDomain.Prices]: 'Ціни',
  [PermissionDomain.Discounts]: 'Знижки',
  [PermissionDomain.MaxDiscounts]: 'Максимальні знижки',
  [PermissionDomain.DiscountMatrices]: 'Матриці знижок',
  [PermissionDomain.Overdrafts]: 'Овердрафти',
  [PermissionDomain.Balances]: 'Баланси',
  [PermissionDomain.FuelOrders]: 'Замовлення пального',
  [PermissionDomain.FuelOrderCoupons]: 'Талони замовлень',
  [PermissionDomain.Coupons]: 'Талони',
  [PermissionDomain.CouponRefundRequests]: 'Заяви на повернення талонів',
  [PermissionDomain.Products]: 'Продукти',
  [PermissionDomain.ProductGroups]: 'Групи продуктів',
  [PermissionDomain.Transactions]: 'Транзакції',
  [PermissionDomain.Drivers]: 'Водії',
  [PermissionDomain.Orders]: 'Замовлення',
  [PermissionDomain.ImportJobs]: 'Імпорти',
  [PermissionDomain.Events]: 'Події',
  [PermissionDomain.Pos]: 'Каса (POS)',
};
